import { render, staticRenderFns } from "./select2.vue?vue&type=template&id=4f217f48"
import script from "./select2.vue?vue&type=script&lang=js"
export * from "./select2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports